/**
 * RGS API 1.07 Request JSON
 */
export class api_107_json_request {
    readonly t: string;
    readonly n?: any;
    readonly m?: number;
    readonly b?: {
        l: number,
        c: number,
        x: number,
        v: number,
        t: number,
    }[];
    readonly d?: any;
    readonly x?: boolean;
    readonly c?: {
        t: number,    // tipo di cheat: griglia 1, vincita sulla linea 2, bonus e freegame 3
        e?: number,   // modalità freegame 1 bonus 2
        s?: number[], // griglia completa
        p?: {
            s: number, // simbolo
            r: number, // ripetizioni del simbolo
        },
};

    constructor(requestToken: string, gn_data: any = null, gameKey: string = "", bet: any = null, mode: number = 0, data: any = null, enabledGamble: boolean = false, acceptGamble: boolean = false, betGamble: any = null, expired: boolean = false, cheat: any = null) {
        this.t = requestToken;
        this.d = {};
        //
        if (gn_data) {
            this.n = gn_data;
        }
        //
        if (bet) {
            this.b = [];
            if (Array.isArray(bet)) {
                bet.forEach(val => {
                    this.b!.push({ l: val.level, c: val.coins, x: val.xunit, v: val.value, t: val.total, });
                });
            } else {
                this.b[0] = { l: bet.level, c: bet.coins, x: bet.xunit, v: bet.value, t: bet.total, };
            }
        }
        //
        if (mode) {
            this.m = mode;
        }
        //
        if (data && typeof data === 'object') {
            this.d = data;
            if (gameKey) {
                this.d.k = gameKey;
            }
        } else if (gameKey) {
            this.d = {
                k: gameKey,
            };
        }
        //
        if (enabledGamble != null) {
            this.d.z = { o: ((enabledGamble) ? 1 : 0) };
        }
        //
        if (acceptGamble != null) {
            this.d.z = { a: ((acceptGamble) ? 1 : 0) }
            if (acceptGamble && betGamble) {
                this.d.z.b = { betGamble };
            }
        }
        //
        if (expired != null) {
            this.x = expired;
        }

        //
        if (cheat) {
            this.c = { t: cheat.c.t, e: cheat.c.e };
            if (cheat.t !== undefined) { this.c.t = cheat.t; } // tipo di cheat: griglia 1, simboli e sue ripetizioni 2, modalità speciali 3
            if (cheat.e !== undefined) { this.c.e = cheat.e; } // modalità speciali
            if (cheat.c.s !== undefined) { this.c.s = cheat.c.s; } // griglia completa
            if (cheat.c.p !== undefined) { this.c.p = cheat.c.p; } // simbolo s e sue ripetizioni t
        }
    }
}

/**
 * RGS API 1.07 Response JSON Credits
 */
export class api_107_json_response_credits {
    readonly total: number;
    readonly bonus: number;

    constructor(credits: any) {
        if (credits && typeof credits === 'object') {
            this.total = credits.t || 0;
            this.bonus = credits.b || 0;
        } else {
            this.total = credits || 0;
            this.bonus = 0;
        }
    }
}

/**
 * RGS API 1.07 Response JSON for the Winnings
 */
export class api_107_json_response_win {
    readonly value: number = 0;
    readonly total: number = 0;

    constructor(win?: { v?: number, t?: number }) {
        if (win) {
            this.value = win.v || 0;
            this.total = win.t || 0;
        }
    }
}

/**
 * RGS API 1.07 Response JSON for Init
 */
export class api_107_json_response_init {
    readonly server: number;
    readonly client: string;
    readonly pending_round: number;
    readonly mode: number;
    readonly data: any;
    readonly win: api_107_json_response_win;
    readonly next: number;
    readonly game: string;

    constructor(init: any) {
        this.server = init.s;
        this.client = init.c;
        this.pending_round = init.p || 0;
        this.mode = init.m || 0;
        this.data = init.d;
        this.win = new api_107_json_response_win(init.w);
        this.next = init.n || 0;
        this.game = init.g || "";
    }
}

/**
 * RGS API 1.07 Response JSON for Play
 */
export class api_107_json_response_play {
    readonly data: any;
    readonly gamble: any;
    readonly win: api_107_json_response_win;
    readonly next: number;
    readonly stop: number;

    constructor(play: any) {
        this.data = play.d;
        this.gamble = play.d.g || null;
        this.win = new api_107_json_response_win(play.w);
        this.next = play.n || 0;
        this.stop = play.s || 0;
    }
}

/**
 * RGS API 1.07 Response JSON Network
 */
export class api_107_json_response_network {
    readonly network: any;

    constructor(network: any) {
        this.network   = (network) ? network : null;
    }
}

/**
 * RGS API 1.07 Response JSON 
 */
export class api_107_json_response {
    public error: number;
    public token: string;
    public credits: api_107_json_response_credits;
    public betTotal!: number;
    public gameResuming: boolean;
    public init!: api_107_json_response_init;
    public play!: api_107_json_response_play;
    public network: api_107_json_response_network;
    public serverHost: string;
    public serverSession: string;

    constructor(root: any, init?: any, play?: any, network?: any) {
        this.token = root.t;
        this.gameResuming = false;
        if (init) {
            this.init = new api_107_json_response_init(init);
            if (this.init.data.b && Array.isArray(this.init.data.b)) {
                this.betTotal = this.init.data.b[0].t || 0;
            }
            this.gameResuming!= (this.init.pending_round && this.init.pending_round != 0);
        }
        if (play) {
            this.play = new api_107_json_response_play(play);
        }
        this.network = new api_107_json_response_network(network);
        this.error = root.e || 0;
        this.credits = root.c ? new api_107_json_response_credits(root.c) : new api_107_json_response_credits(null);
        //
        this.serverHost = root.h || null;
        this.serverSession = root.x || null;
    }

    public get data(): api_107_json_response_init | api_107_json_response_play {
        return ((this.init) || (this.play));
    }

}
